import { CircularProgress } from '@mui/material';
import React from 'react';

export const CoverAllLoad = () => {
  return (
    <div className={'absolute top-0 left-0 w-full h-full'}>
      <div
        className={`flex items-center justify-center w-full h-full bg-black bg-opacity-20`}
      >
        <CircularProgress className="text-secondary" size={96} thickness={8} />
      </div>
    </div>
  );
};
